<template>
  <div class="aqi">
    <div class="label label__full">
      {{ $t('map.popover.currentAqi') }}
    </div>
    <div class="label label__abbr">
      {{ $t('map.popover.abbrevAqi') }}
    </div>
    <v-btn
      class="reading"
      variant="text"
      @click="openAQIDialog"
      :style="aqiStyles(numericAqi)"
      data-cy="currentAQI"
    >
      {{ validateAQI(numericAqi) }}
    </v-btn>
    <device-aqi-dialog :open="aqiOpen" @close="closeAQIDialog()" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { getAQIStyles, useAqiValidator } from '@/services/map'
import deviceAQIDialog from '@/components/dialogs/DeviceAQIDialog.vue'

export default defineComponent({
  name: 'aqiMainValue',
  props: {
    aqi: { type: [Number, String] as PropType<number | string>, required: true },
    aqiType: { type: Number, default: 0 },
    measurementType: { type: Number, default: 0 }
  },
  components: {
    'device-aqi-dialog': deviceAQIDialog
  },
  setup() {
    const { validateAQI } = useAqiValidator()
    return { validateAQI }
  },
  data() {
    return {
      aqiOpen: false
    }
  },
  computed: {
    numericAqi(): number {
      return typeof this.aqi === 'number' ? this.aqi : Number.NaN
    }
  },
  methods: {
    aqiStyles(aqi: number): string {
      const styles = getAQIStyles(aqi, this.aqiType, this.measurementType)

      if (styles.background === '#eeeeee') {
        return `color:${styles.color};transition:background-color 0s ease-in;`
      }
      return `background-color:${styles.background};color:${styles.color}`
    },
    openAQIDialog(): void {
      this.aqiOpen = true
    },
    closeAQIDialog(): void {
      this.aqiOpen = false
    }
  }
})
</script>

<style lang="scss" scoped>
.aqi {
  padding: 0px 8px 0px 8px;
  .label {
    white-space: nowrap;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
    font-size: 13px;

    &__abbr {
      display: none;
    }
    @media (max-width: 460px) {
      font-size: 12px !important;
    }
  }

  .reading {
    background-color: #eeeeee;
    color: white;
    font-size: 30px;
    text-align: center;
    letter-spacing: 0px;
    font-weight: 500;
    border-radius: 2px;
    height: 39px;
    width: 70px;
    @media (max-width: 400px) {
      font-size: 24px;
      width: 60px;
    }
  }

  @media (max-width: 460px) {
    max-width: 90px;
    padding: 0 !important;
    margin-left: 6px;
    .label__full {
      display: none;
    }
    .label__abbr {
      display: block;
    }
    .reading {
      width: 60px;
    }
  }

  .widget-xs &,
  .widget-sm & {
    max-width: 90px;
    padding: 0 !important;
    margin-left: 6px;
    .label__full {
      display: none;
    }
    .label__abbr {
      display: block;
    }
    .reading {
      width: 60px;
    }
  }
}
</style>
